import { render, staticRenderFns } from "./Tabulate.vue?vue&type=template&id=1c63c553&scoped=true&"
import script from "./Tabulate.vue?vue&type=script&lang=js&"
export * from "./Tabulate.vue?vue&type=script&lang=js&"
import style0 from "./Tabulate.vue?vue&type=style&index=0&id=1c63c553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63c553",
  null
  
)

export default component.exports